module.exports = __webpack_public_path__ + "static/ishimizu-e90467faa48328185aa826e55696c755.png";